import React from "react"
import { Toggle } from "../Toggle"
import { SelectMenuCategory } from "../SelectMenuCategory"

interface MenuFiltersProps {
  options: any[],
  scrollOffset: Number
}

class MenuFiltersInner extends React.Component<MenuFiltersProps> {
  constructor(props: MenuFiltersProps) {
    super(props)

    this.getOptions = this.getOptions.bind(this)
  }

  getOptions() {
    const { options } = this.props

    return options.reduce((collection, category) => {
      collection.push({ label: category.name, value: category.anchorName })
      return collection
    }, [])
  }

  handleSelect(anchor) {
    const element = document.getElementById(anchor)
    element.scrollIntoView({
      block: "start",
      behavior: "smooth",
    })
  }

  render() {
    return (
      <aside role="nav" className="sticky top-4" style={{ top: "16px" }}>
        <SelectMenuCategory
          options={this.getOptions()}
          onSelect={this.handleSelect}
          className="block w-full p-2 border border-indigo rounded sm:hidden mb-8"
        />
        <Toggle
          options={this.getOptions()}
          onSelect={this.handleSelect}
          listClasses="block text-lg list-outside hidden sm:block"
          activeClassName="list-disc"
          inactiveClassName="list-none"
          buttonClassName="px-2 py-2 text-left"
        />
      </aside>
    )
  }
}

export function MenuFilters(props: MenuFiltersProps) {
  return <MenuFiltersInner {...props} />
}
